var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.qty
    ? _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "end"
          }
        },
        [
          _c(
            "span",
            { staticStyle: { width: "80px" } },
            [
              _c("RenderMoneyColumnValue", {
                attrs: { value: _vm.value, "max-fraction-digits": 0 }
              }),
              _vm._v(" R$\n  ")
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { padding: "0 5px" } }, [_vm._v("|")]),
          _vm._v(" "),
          _c("span", { staticStyle: { width: "30px" } }, [
            _vm._v(" " + _vm._s(_vm.qty) + " # ")
          ]),
          _vm._v(" "),
          _c("span", { staticStyle: { padding: "0 5px" } }, [_vm._v("|")]),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { width: "80px" } },
            [
              _c("RenderMoneyColumnValue", {
                attrs: { value: _vm.value / _vm.qty, "max-fraction-digits": 0 }
              }),
              _vm._v("\n    TM\n  ")
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { padding: "0 5px" } }, [_vm._v("|")]),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { width: "50px" } },
            [
              _c("RenderPercentageColumnValue", {
                attrs: { value: _vm.percent }
              }),
              _vm._v("\n    H\n  ")
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }